export const BUTTON_TYPES = {
  default: {
    label: null,
    type: "button",
    classes: ["btn"],
    styles: null,
    glyphicon: null,
  },
  search: {
    label: "検索する",
    type: "submit",
    classes: ["btn-primary", "font-weight-bold"],
  },
  back: {
    classes: ["btn-default", "font-weight-bold"],
    label: "戻る",
  },
  cancel: {
    classes: ["btn-default", "font-weight-bold"],
    label: "キャンセル",
  },
  new: {
    label: "新規追加",
    classes: ["btn-primary", "font-weight-bold"],
  },
  bulk: {
    label: "一括登録",
    classes: ["btn-primary", "font-weight-bold"],
  },
  add: {
    label: "追加する",
    classes: ["btn-primary", "font-weight-bold"],
  },
  edit: {
    label: "編集する",
    classes: ["btn-primary", "font-weight-bold"],
  },
  save: {
    label: "登録する",
    classes: ["btn-primary", "font-weight-bold"],
  },
  delete: {
    label: "削除する",
    classes: ["btn-warning", "font-weight-bold"],
  },
  detail: {
    label: "詳細",
    classes: ["btn-primary", "font-weight-bold"],
  },
  success: {
    classes: ["btn-success", "font-weight-bold"],
  },
  warning: {
    classes: ["btn-warning", "font-weight-bold"],
  },
  primary: {
    classes: ["btn-primary", "font-weight-bold"],
  },
  "primary-xs": {
    classes: ["btn-primary", "btn-xs"],
  },
  "warning-xs": {
    classes: ["btn-warning", "btn-xs"],
  },
  "to-list": {
    label: "一覧へ",
    glyphicon: "list",
  },
  "to-prev": {
    label: "前の画面へ",
    glyphicon: "list-alt",
  },
  "to-login-form": {
    label: "ログイン画面に戻る",
    glyphicon: "arrow-left",
  },
  download: {
    glyphicon: "download-alt",
  },
  execute: {
    label: "実行",
    classes: ["btn-primary"],
    glyphicon: "flash",
  },
};
